import React from 'react';
import { motion } from 'framer-motion';

// Heavy fade-up + de-blur as an element scrolls into view. Use for cards/sections — NEVER for
// table rows. Runs once. Respects prefers-reduced-motion via the global CSS clamp + Framer.
export function MotionReveal({ children, delay = 0, className, y = 16 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y, filter: 'blur(6px)' }}
            whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.8, ease: [0.32, 0.72, 0, 1], delay }}
        >
            {children}
        </motion.div>
    );
}
